const labelStyles = {
  typography: {
    // Labels
    label1: {
      fontSize: "0.875rem", // 14
      lineHeight: 1.28571, // 18px / 14px
    },
    label2: {
      fontSize: "0.75rem", // 12
      lineHeight: 1.33333, // 16px / 12px
    },
    label3: {
      fontSize: "0.6875rem", // 11
      lineHeight: 1.36364, // 15px / 11px
    },
    label4: {
      fontSize: "0.625rem", // 10
      lineHeight: 1.4, // 14px / 10px
    },
    overline: {
      fontSize: "0.75rem", // 12
      lineHeight: 2.16667, // 266
    },
    caption: {
      fontSize: "0.75rem", // 12
      lineHeight: 1.38333, // 166
      letterSpacing: "0.4px",
    },
  },
};
export default labelStyles;
